import React from 'react'

const Analytics_test = () => {
  return (
    <div>Analytics_test</div>
  )
}

export default Analytics_test